export default [{
    text: 'Свободная продажа',
    value: 'free',
}, {
    text: 'Альтернатива',
    value: 'alternative',
}, {
    text: '214-ФЗ',
    value: 'fz214',
}, {
    text: 'Договор уступки права требования',
    value: 'dupt',
}, {
    text: 'Договор ЖСК',
    value: 'dzhsk',
}, {
    text: 'Предварительный договор купли-продажи',
    value: 'pdkp',
}, {
    text: 'Договор инвестирования',
    value: 'investment',
}];
